var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "75DD251D-E708-4C31-AD14-2F3710D9B292") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rides---Quotes",
    transform: "translate(-1340.000000, -258.000000)",
    stroke: "#A1A5B3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(148.000000, 257.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row-copy-6",
    transform: "translate(23.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1168.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-icon/quote"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_coin_68038_000000",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1 C14.962375,1 19,5.037625 19,10 C19,14.962375 14.962375,19 10,19 C5.037625,19 1,14.962375 1,10 C1,5.037625 5.037625,1 10,1 Z M10,0 C4.47666667,0 0,4.47666667 0,10 C0,15.5233333 4.47666667,20 10,20 C15.5233333,20 20,15.5233333 20,10 C20,4.47666667 15.5233333,0 10,0 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.042,14.43 C8.461,14.43 7.399,13.51 7.399,12.143 C7.399,11.869 7.623,11.643 7.899,11.643 C8.175,11.643 8.399,11.869 8.399,12.143 C8.399,13.336 9.657,13.43 10.042,13.43 C10.427,13.43 11.686,13.336 11.686,12.143 C11.686,11.399 11.395,11.227 10.166,10.621 L9.478,10.28 C8.271,9.684 7.399,9.254 7.399,7.86 C7.399,6.484 8.461,5.559 10.042,5.559 C11.605,5.559 12.655,6.484 12.655,7.86 C12.655,8.136 12.431,8.36 12.155,8.36 C11.879,8.36 11.655,8.136 11.655,7.86 C11.655,6.653 10.42,6.559 10.042,6.559 C9.248,6.559 8.399,6.901 8.399,7.86 C8.399,8.605 8.69,8.777 9.92,9.383 L10.609,9.725 C11.814,10.32 12.685,10.749 12.685,12.143 C12.686,13.51 11.623,14.43 10.042,14.43 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,6.5 C9.724,6.5 9.5,6.276 9.5,6 L9.5,5 C9.5,4.724 9.724,4.5 10,4.5 C10.276,4.5 10.5,4.724 10.5,5 L10.5,6 C10.5,6.276 10.276,6.5 10,6.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,15.5 C9.724,15.5 9.5,15.275 9.5,15 L9.5,14 C9.5,13.725 9.724,13.5 10,13.5 C10.276,13.5 10.5,13.725 10.5,14 L10.5,15 C10.5,15.275 10.276,15.5 10,15.5 Z",
    id: "Path"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.c7d90ad3abc19f1f33539018647b92a7.svg";
export { ForwardRef as ReactComponent };